import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import { MainService } from 'app/resources/services/index';

@Component({
  selector: 'app-loja',
  templateUrl: './loja.component.html'
})
export class LojaComponent implements OnInit {
  processando: boolean;
  pedidos: any;

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.processando = true;
    this.mainService.saldoService.initialize();
    this.mainService.parceiroService.activate();
    this.mainService.lojaService.categoriaSelecionada = { nome: '' };
    this.mainService.http.pathRest().get('loja/pedidos/', true)
      .subscribe(
        sucesso => {
          this.pedidos = sucesso.json();
          this.processando = false;
        }, erro => {
          this.processando = false;
        });
  }

  public visualizarPedido(pedido) {
    this.mainService.lojaService.pedidoSelecionado = pedido;
    this.mainService.lojaService.pedidoSelecionado.itens = [];

    if (this.mainService.lojaService.pedidoSelecionado.frete.frete === 'transportadora') {
      this.mainService.lojaService.pedidoSelecionado.frete.descricao = 'Transportadora';
    } else if (this.mainService.lojaService.pedidoSelecionado.frete.frete === 'sedex_10') {
      this.mainService.lojaService.pedidoSelecionado.frete.descricao = 'Sedex 10';
    } else {
      this.mainService.lojaService.pedidoSelecionado.frete.descricao = '';
    }
    this.mainService.http.pathRest().get('loja/pedidos/' + pedido.id + '/' + pedido.uuid + '/itens/', true)
      .subscribe(
        sucesso => {
          this.mainService.lojaService.pedidoSelecionado.itens = sucesso.json();
          this.router.navigate(['/loja/pedido']);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/loja/loja.component.ts